import React from 'react'
import cn from 'classnames'

import { BookEnum } from '@interfaces/BookEnum'
import { OrientationEnum } from '@interfaces/OrientationEnum'
import { WriterStatusEnum } from '@interfaces/WriterStatusEnum'
import { FontFamilyEnum } from '@interfaces/FontFamilyEnum'
import { NavigationReadingPage } from '@components/NavigationReadingPage'
import { TiptapViewer } from '@components/TiptapViewer'
import { HorizontalStyle } from '@components/HorizontalStyle'
import { VerticalStyle } from '@components/VerticalStyle'
import { ReadingPageHeader } from '@components/ReadingPageHeader'
import { ReadingPageFooter } from '@components/ReadingPageFooter'
import { ThemeEnum } from '@hooks/contexts/ThemeContext/interface'
import { ChapterPageProps } from './interface'
import { ChapterPageContainer } from './components/ChapterPageContainer'

export function ChapterPage({
  data,
  bookId,
  chapterId,
  theme,
  fontSize,
  lineHeight,
  fontFamily,
}: ChapterPageProps) {
  return (
    <div
      className={cn('dark:bg-dark-6', {
        'bg-gray-1': theme === ThemeEnum.LIGHT,
        'bg-sepia-3': theme === ThemeEnum.SEPIA,
        'bg-dark-7': theme === ThemeEnum.DARK,
      })}
    >
      <NavigationReadingPage
        bookId={bookId}
        chapterName={data?.chapterName || ''}
        chapterTitle={data?.chapterTitle || ''}
      />
      <ChapterPageContainer
        className='desktop-tablet:!p-[30px_0_80px] mobile:!p-[0_0_0]'
        theme={theme}
      >
        <ReadingPageHeader
          chapterName={data?.chapterName || ''}
          chapterTitle={data?.chapterTitle || ''}
          totalPage={
            data?.book?.bookType === BookEnum.MANGA &&
            data?.book?.orientation === OrientationEnum.HORIZONTAL
              ? data?.chapterPages.length
              : undefined
          }
        />

        {data?.book?.bookType === BookEnum.NOVEL && (
          <TiptapViewer
            className={cn('chapter-content text-secondary dark:text-gray-4', {
              'is-js-font': [FontFamilyEnum.JS_JINDARA].includes(fontFamily),
              'font-14': fontSize === 14,
              'font-16': fontSize === 16,
              'font-18': fontSize === 18,
              'font-20': fontSize === 20,
              'font-22': fontSize === 22,
              'font-24': fontSize === 24,
              'line-height-125': lineHeight === 1.25,
              'line-height-15': lineHeight === 1.5,
              'line-height-2': lineHeight === 2,
              'line-height-25': lineHeight === 2.5,
              'line-height-3': lineHeight === 3,
              'font-notoSerif': fontFamily === FontFamilyEnum.NOTO_SERIF,
              'font-baiJamjuree': fontFamily === FontFamilyEnum.BAI_JAMJUREE,
              'font-jsJindara': fontFamily === FontFamilyEnum.JS_JINDARA,
              'font-sarabun': fontFamily === FontFamilyEnum.SARABUN,
              'font-trirong': fontFamily === FontFamilyEnum.TRIRONG,
            })}
            value={data.chapterPages[0]?.content}
          />
        )}
        {data?.book?.bookType === BookEnum.MANGA &&
          data.book.orientation === OrientationEnum.HORIZONTAL && (
            <HorizontalStyle
              chapterPages={data.chapterPages}
              chapterId={chapterId}
              isReview
            />
          )}
        {data?.book?.bookType === BookEnum.MANGA &&
          data.book.orientation === OrientationEnum.VERTICAL && (
            <VerticalStyle chapterPages={data.chapterPages} isReview />
          )}

        <ReadingPageFooter
          fontFamily={fontFamily}
          bookId={bookId}
          prevId={data?.prevId || null}
          nextId={data?.nextId || null}
          isWriter={
            data?.book?.penName?.user?.writer?.status ===
            WriterStatusEnum.APPROVED
          }
          affiliation={data?.book?.penName?.user?.writer?.affiliation}
          displayName={data?.book?.penName?.user?.displayName || ''}
          penName={data?.book?.penName?.firstPenName || ''}
          penNameCover={data?.book?.penName?.user?.avatarImgPath || ''}
          messageFormWriter={data?.writerMessage}
          bookType={data?.book?.bookType}
          slug={data?.book?.penName?.user?.profilePageSlug || ''}
          isAdmin={data?.book?.penName?.user.isAdmin || false}
          email={data?.book?.penName?.user.email || ''}
        />
      </ChapterPageContainer>
    </div>
  )
}
